import { defineStore } from 'pinia'
import { ref } from 'vue'

const THEME_STORAGE_KEY = 'kp-theme'

function readStoredTheme(): 'light' | 'dark' {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY)
    if (saved === 'dark' || saved === 'light') return saved
  } catch {
    // ignore
  }
  return 'light'
}

export const useSettingsStore = defineStore('settings', () => {
  // State
  const theme = ref<'light' | 'dark'>(readStoredTheme())
  const layoutMode = ref<'top' | 'left'>('left')
  const primaryColor = ref<string>('#fe2062')

  // Actions
  const setTheme = (newTheme: 'light' | 'dark') => {
    theme.value = newTheme
    try {
      localStorage.setItem(THEME_STORAGE_KEY, newTheme)
    } catch {
      // ignore
    }
  }

  const setLayoutMode = (mode: 'top' | 'left') => {
    layoutMode.value = mode
  }

  const setPrimaryColor = (color: string) => {
    primaryColor.value = color
  }

  return {
    theme,
    layoutMode,
    primaryColor,
    setTheme,
    setLayoutMode,
    setPrimaryColor
  }
})
